<template>
  <footer class="copyright-bottom">
    <div>
      <p>
      © 2019 <a href="https://www.wetogether.co/">WeTogether.co</a> All Rights Reserved.
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  data(){
    return{
      msg: 'Hello vue'
    }
  }
}
</script>

<style scoped>
.copyright-bottom {
    position: fixed;
    background: #fff;
    width: 100%;
    bottom: 0;
    z-index: 199;
    color: #7a7a7ad5;
    justify-content: center;
    text-align: center;
}
.copyright-bottom div {
    display: inline-block;
    /* float: left; */
    text-align:right;
}
.copyright-bottom p {
    text-align:center;
}
.copyright-bottom a {
    width: 100%;
    /* display: inline-block; */
    font-size: 16px;
    color: #7a7a7ad5;
    text-decoration: none;
    /* line-height: 12px; */
}
</style>
